

<div class="">
  <div *ngIf="label">{{ label | translate }}</div>
  <table class="date-picker__calendar-table">
    <thead class="date-picker__calendar-header" *ngIf="columnsLabels && columnsLabels.length">
      <tr class="date-picker__calendar-weekdays">
        <th *ngFor="let label of columnsLabels">{{ label | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of grid">
        <td class="date-picker__calendar-cell"
            *ngFor="let cell of row"
            [class.date-picker__calendar-cell--selected]="cell.selected"
            [class.date-picker__calendar-cell--disabled]="cell.disabled"
            [class.date-picker__calendar-cell--highlighted]="cell.emphasis === 'high'"
            [class.date-picker__calendar-cell--outside-month]="cell.emphasis === 'low'"
            [class.date-picker__calendar-cell--in-range]="cell.range"
            (click)="cell.label && click(cell); stopPropagation && $event.stopPropagation();"
            (mouseenter)="cell.label && enter(cell)">
          <span class="date-picker__calendar-cell-content" *ngIf="cell.label">{{ cell.label | translate }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
